module.exports = __webpack_public_path__ + "img/img-zhilian-s10-tuya.7e505b32.png";